import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { DataCollectorService } from '../../core/services/data_collector_services/data_collector_service.service';

@Injectable({
  providedIn: 'root'
})
export class TextEditorService {
  public focusEditor: ReplaySubject<boolean | any> = new ReplaySubject<boolean | any>(1);
  get textEditorApiUrls(): any{
    return {
    upload: `${this.datacollectorservice.baseurl()}/misc/upload`,
    templateUrl: `${this.datacollectorservice.baseurl()}/misc/email_template`,
    previewTemplateUrl: `${this.datacollectorservice.baseurl()}/misc/template_preview`
  }};

  constructor(private datacollectorservice: DataCollectorService) {
    this.focusEditor.next(false);
  }

  getSuggestedFields(availableComponents: any): any[] {
    let suggestedFields: any[] = [];
    if (availableComponents?.length) {
      const componentsObject: any = {};
      availableComponents.forEach((component: any) => {
        const objectKey: string = component?.groupType === 'custom_group' ? component.groupName : component?.groupType;
        if (!componentsObject[objectKey]) {
          componentsObject[objectKey] = [];
        }
        componentsObject[objectKey].push(this.updateSuggestedFields(component.label, component.key, false));
      });
      if (Object.keys(componentsObject)?.length) {
        if (componentsObject.default) {
          suggestedFields.push(this.updateSuggestedFields('Default Fields', 'default_field_header', true));
          suggestedFields = [...suggestedFields, ...componentsObject['default']];
        }
        if (componentsObject.custom_default) {
          suggestedFields.push(this.updateSuggestedFields('Custom Fields - Default', 'custom_default_field_header', true));
          suggestedFields = [...suggestedFields, ...componentsObject['custom_default']];
        }
        Object.keys(componentsObject)?.forEach((key: string) => {
          if (!['default', 'custom_default'].includes(key)) {
            suggestedFields.push(this.updateSuggestedFields(`Custom Fields - ${key}`, 'custom_group_field_header', true));
            suggestedFields = [...suggestedFields, ...componentsObject[key]];
          }
        });
      }
    }
    return suggestedFields;
  }

  private updateSuggestedFields(text: string, value: string, isHeader: boolean): any {
    return {
      type: 'cardmenuitem',
      value: isHeader ? 'field_header' : value,
      text: text,
      items: [
        {
          type: 'cardcontainer',
          direction: 'vertical',
          items: [
            {
              type: 'cardtext',
              text: text,
              classes: isHeader ? ['font-semibold', 'text-lg', 'primary-font', 'p-1'] : ['text-base', 'primary-font', 'p-1']
            }
          ]
        }
      ]
    };
  }
}
